
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class TaxAssesmentDisclaimer extends Vue {
  private get getCurrentLang() {
    return this.$i18n.locale;
  }
}
